<template>
  <div class="linePreview">
    <div class="head">
    <p>LINEフレックスプレビュー</p>
    </div>
    <div class="chatInner">
      <div class="brandName">
        <img :src="isV2Channel ? 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line_logo_circle.png' : 'https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line_logo_circle.png'" alt="LINEのアイコン" width="42" height="42" class="mr-2 marketing-img">
        <v-flex class="pl-1">
          <div class="font-weight-bold text--darken-2">{{ brandName }}</div>
        </v-flex>
      </div>
      <VueSlickCarousel :key="carouselKey" :focusOnSelect="false" :infinite="false" :slidesToShow="1" :variableWidth="true" :draggable="true" >
        <div v-for="(type, index) in marketingLineTemplateTypeList" :key="index" class="templates-wrap">
          <line-template-text-button v-if="type === 'TEXT_BUTTON' " :order="index"></line-template-text-button>
          <line-template-image-button v-if="type === 'IMAGE_BUTTON' " :order="index"></line-template-image-button>
          <line-template-image-link v-if="type === 'IMAGE' " :order="index"></line-template-image-link>
          <line-template-image-text-button v-if="type === 'IMAGE_TEXT_BUTTON' " :order="index"></line-template-image-text-button>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import lineTemplateImageTextButton from '../../line/components/lineTemplateImageTextButton'
import lineTemplateImageButton from '../../line/components/lineTemplateImageButton'
import lineTemplateImageLink from '../../line/components/lineTemplateImageLink'
import lineTemplateTextButton from '../../line/components/lineTemplateTextButton'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  metaInfo: {
    title: 'プレビュー'
  },
  data () {
    return {
      dialog: false,
      isV2Channel: false,
      type: '',
      object: [],
      brandName: '',
      carouselKey: 0
    }
  },
  watch: {
    marketingLineTemplateTypeList () {
      this.forceRerender()
    }
  },
  components: {
    lineTemplateTextButton, lineTemplateImageTextButton, lineTemplateImageButton, lineTemplateImageLink, VueSlickCarousel
  },
  created () {
    if (this.$route.query.marketingId) {
      this.isV2Channel = this.$route.query.isV2Channel
      this.marketingId = this.$route.query.marketingId
    }
  },

  destroyed () {
  },
  computed: {
    ...mapGetters([
      'marketingLineTemplateContent',
      'marketingLineTemplateContentType',
      'marketingLineTemplateTypeList'
    ])
  },
  mounted () {
    if (this.$route.query.marketingId) {
      this.changeTemplateContent()
    }
  },
  methods: {
    ...mapMutations([
      'selectLineTemplate',
      'changeLineTemplateView'
    ]),
    changeTemplate (type) {
      this.type = type
    },
    changeTemplateContent () {
      try {
        this.$http.get('/api/marketing/v2/fetchMarketingContent', {
          params: {
            marketingId: this.marketingId
          }
        })
          .then(result => {
            const response = result.data
            if (response.code === 0) {
              let selectdata = {
                marketingId: response.data.marketingFlowViews[0].data.marketingTemplateId,
                marketingName: response.data.marketingFlowViews[0].data.marketingTemplateTitle
              }
              this.selectLineTemplate(selectdata)
              this.changeLineTemplateView(response.data.marketingFlowViews[0].data)
            } else {
              throw response.message
            }
          })
          .catch(errorMsg => {
            this.$alertMsg(errorMsg)
          })
      } catch (e) {
        console.log(e)
      }
    },
    brandInfo () {
      this.$http.get('/api/agent/fetchBrands').then(result => {
        if (result.data.code === 0) {
          this.brandId = this.brands[0].id
          this.brandName = this.brands[0].name
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    },
    forceRerender () {
      this.carouselKey += 1
    }
  }
}
</script>

<style lang="scss" scoped>
  @import url("components/fragments/css/marketingFlexEditor.css");
  .linePreview {
    height: 100%;
    background: url(https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/line_bg.svg)no-repeat center / cover;
    .head {
      padding: 16px 20px;
      background: #24324B;
      p {
        position: relative;
        margin: 0;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        :before {
          position: absolute;
          content: "";
          background: url();
          width: 20px;
          height: 21px;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
      }
    }
    .chatInner {
      padding: 20px;
      .brandName {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      .templates-wrap {
        padding-right: 10px;
      }
      .template-edit-area {
        &:hover {
          transform: none;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.14);
        }
      }
      .line_temp {
        &__ttl {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 6px;
        }
      }
      .add-btn-basic {
        border: none;
        background: none;
        margin-top: 20px;
        &:hover {
          border: none;
        }
        .v-list__tile__title {
          text-align: center;
        }
        .v-list__tile__action {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/marketing/marketingPreview.vue